webpackJsonp([148082031400883],{

/***/ 395:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"id":"/opt/build/repo/content/posts/2017-09-17--bci-publications/index.md absPath of file >>> MarkdownRemark","html":"<p>I am always looking for excuses to build an application that will actually be used by someone other than myself. My girlfriend(Amanda)s brother(Jamie) is working towards completion of his PhD in Neuroscience has been working for the State University of New York. SUNY has been a large contributor of publications surrounding research in Brain-Computer Interfaces which Jamie had been researching during his time in the PhD program.</p>\n<h1>The Issue</h1>\n<h1>The Solution</h1>\n<h1>What Was Learned</h1>","frontmatter":{"title":"Building a Publication Management App","subTitle":null,"date":"September 17, 2017","cover":{"childImageSharp":{"resize":{"src":"/static/photo-1463852247062-1bbca38f7805-cover-e7a129318b43a8a58bbc8fe8219cda1d-ada8c.jpg"}}}}}},"pathContext":{"path":"/bci-publications/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---bci-publications-c170ed14eef111359c1d.js